<template>
  <div>
    <el-alert :closable="false" title="以下信息不能主动修改，如需修改，请联系管理员" type="warning"/>
    <div class="list">
      <el-row :gutter="20">
        <el-col :span="3" :xs="12">
          <div>用户名:</div>
        </el-col>
        <el-col :span="8" :xs="12">
          <div>{{ user.name }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="3" :xs="12">
          <div>手机号码:</div>
        </el-col>
        <el-col :span="8" :xs="12">
          <div>{{ user.phone }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="3" :xs="12">
          <div>联系地址:</div>
        </el-col>
        <el-col :span="8" :xs="12">
          <div>{{ user.address }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="3" :xs="12">
          <div>余额</div>
        </el-col>
        <el-col :span="8" :xs="12">
          <div>{{ user.money }}</div>
        </el-col>
      </el-row>
      <!-- <el-row v-if="agentInfo.useChargeToBalance !== 1"  :gutter="20">
        <el-col :span="3" :xs="12">
          <div>自动提现</div>
        </el-col>
        <el-col :span="8" :xs="12">
          <div>{{ user.autoWithdraw === 1 ? '开启' : '未开启' }}</div>
        </el-col>
      </el-row> -->
      <el-row :gutter="20">
        <el-col :span="3" :xs="12">
          <div>公众号</div>
        </el-col>
        <el-col :span="8" :xs="12">
          <div>{{ user.hasApp === '1' ? '已绑定' : '未绑定' }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="3" :xs="12">
          <div>商户平台</div>
        </el-col>
        <el-col :span="8" :xs="12">
          <div>{{ user.mchid === '1' ? '已绑定' : '未绑定' }}</div>
        </el-col>
      </el-row>
      <el-row v-if="agentInfo.useChargeToBalance !== 1" :gutter="20">
        <el-col :span="3" :xs="12">
          <div>提现审核</div>
        </el-col>
        <el-col :span="8" :xs="12">
          <div>{{ user.withdrawNeedCheck === '0' ? '不需要' : '需要' }}</div>
        </el-col>
      </el-row>
      <!-- <el-row v-if="agentInfo.useChargeToBalance !== 1" :gutter="20">
        <el-col :span="3" :xs="12">提现方式</el-col>
        <el-col :span="3" :xs="12">{{ way }}</el-col>
      </el-row> -->
      <template v-if="user.bankNum">
        <el-row :gutter="20">
          <el-col :span="3" :xs="12">
            <div>银行卡</div>
          </el-col>
          <el-col :span="8" :xs="12">
            <div>{{ user.bankNum }}</div>
          </el-col>
        </el-row>
      </template>
      <template v-if="user.bankName">
        <el-row :gutter="20">
          <el-col :span="3" :xs="12">
            <div>账户名称</div>
          </el-col>
          <el-col :span="8" :xs="12">
            <div>{{ user.bankName }}</div>
          </el-col>
        </el-row>
      </template>

      <template v-if="user.bankName1">
        <el-row :gutter="20">
          <el-col :span="3" :xs="12">
            <div>所属银行</div>
          </el-col>
          <el-col :span="8" :xs="12">
            <div>{{ user.bankName1 }}</div>
          </el-col>
        </el-row>
      </template>
      <template v-if="user.weChatUser">
        <el-row :gutter="20">
          <el-col :span="3" :xs="12">
            <div>微信昵称</div>
          </el-col>
          <el-col :span="8" :xs="12">
            <div>{{ user.weChatUser.nickName }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="3" :xs="12">
            <div>微信手机号:</div>
          </el-col>
          <el-col :span="8" :xs="12">
            <div>{{ user.weChatUser.phone }}</div>
          </el-col>
        </el-row>
      </template>
      <el-row :gutter="20">
        <el-col :span="3" :xs="12">掉线推送微信</el-col>
        <el-col :span="3" :xs="12">{{ user.bindPushWeChat === true ? '已绑定' : '未绑定' }}</el-col>
        <el-col v-if="user.bindPushWeChat" :span="3" :xs="12">
          <el-button type="danger" @click="pustBind">解绑推送微信</el-button>
        </el-col>
      </el-row>
    </div>
    <div v-if="!user.bindPushWeChat">
      <el-button type="primary" @click="bind">绑定推送微信</el-button>
    </div>
    <div v-if="imgShow">
      <img :src="img" alt="微信绑定二维码">
      <div>
        二维码在1分钟内有效,请快速绑定
      </div>
    </div>
  </div>
</template>

<script>
import agentGetBindWeChatPUshSCode from "@/api/user/agent-manage/agentGetBindWeChatPUshSCode";
import agentGetOwnDetails from "@/api/user/agent-manage/agentGetOwnDetails";
import agentUnbindWeChatPush from "@/api/user/agent-manage/agentUnbindWeChatPush";
import createdMixin from "@/mixin/createMixin";
import resDisposeMixin from "@/mixin/resDisposeMixin";
import UserInfoStore from "@/utils/UserInfoStore";
import bankList from "@/utils/bankList";
import QRCode from "qrcode";

export default {
  name: "UserInfo",
  mixins: [createdMixin, resDisposeMixin],
  data() {
    return {
      options: bankList,
      agentInfo: UserInfoStore.getInfo(),
      user: {
        id: undefined,
        bindPushWeChat: undefined,
        name: undefined,
        phone: undefined,
        address: undefined,
        weChatUser: {
          nickName: undefined,
          phone: undefined
        }
      },
      img: undefined,
      imgShow: false
    }
  },
  computed: {
    way() {
      if (this.user.bankNum !== "" && this.user.bankNum !== undefined) {
        return "银行卡"
      } else if (this.user.weChatUser !== undefined) {
        return "微信账户"
      } else {
        return "未绑定"
      }
    }
  },
  methods: {
    pustBind() {
      agentUnbindWeChatPush(this.user.id).then(res => {
        this.resFetch({res})
      })
    },
    bind() {
      agentGetBindWeChatPUshSCode().then(res => {
        let url = `${process.env.VUE_APP_WE_URL}/BindPush?agentCode=${res.data.agentCode}&bindCode=${res.data.code}`;
        QRCode.toDataURL(url).then(qt => {
          this.img = qt;
          this.imgShow = true;
        })
      });
    },
    fetchData() {
      agentGetOwnDetails().then(res => {
        for (var item in bankList) {
          if (bankList[item].num === res.data.bankId) {
            res.data.bankName1 = bankList[item].value
          }
        }
        this.user = res.data;

      })
    },
  }
}
</script>

